import type { IconData } from '@stacksjs/iconify-core'

export const codingAppsWebsites: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 1.53H32v28.95h-1.52ZM1.52 30.48h28.96V32H1.52ZM28.95 3.05H3.05v25.91h25.9ZM15.24 6.1h1.52v6.09h-1.52Zm-6.1 0h4.57v6.09H9.14Zm-3.04 0h1.52v6.09H6.1Zm0 7.62h4.57v6.09H6.1Zm6.09 12.19h-1.52v1.52H9.14v-1.52h1.53v-3.05H9.14v-1.52h1.53v1.52h1.52Zm0-12.19h1.52v6.09h-1.52Zm6.1 13.71h-4.58v-1.52h4.58Zm-3.05-7.62v-6.09h4.57v6.09Zm7.62 3.05h-1.53v3.05h1.53v1.52h-1.53v-1.52h-1.52v-3.05h1.52v-1.52h1.53Zm0-3.05h-1.53v-6.09h1.53Zm0-7.62h-4.57V6.1h4.57Zm3.04 7.62h-1.52v-6.09h1.52Zm0-7.62h-1.52V6.1h1.52Z\"/><path fill=\"currentColor\" d=\"M19.81 7.62h1.52v3.05h-1.52Zm-3.05 7.62h1.53v3.05h-1.53Zm-6.09-7.62h1.52v3.05h-1.52Zm-3.05 7.62h1.52v3.05H7.62ZM1.52 0h28.96v1.53H1.52ZM0 1.53h1.52v28.95H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default codingAppsWebsites
